const PATHS = {
    HOME: '/',
    POST: '/:breadcrumb/:tag',
    NOT_FOUND: '/404',
  };
  
  export default PATHS;
  